import React from 'react'
import { PhoneInput } from 'react-international-phone'

const PhoneInputWrapper = React.forwardRef((props, ref) => (
  <label className='game-form-label'>
    <PhoneInput
      innerRef={ref}
      defaultCountry='us'
      value={props.phone}
      className='phone-input-wrapper'
      inputClassName='form-control'
      error={true}
      inputProps={{
        name: 'phone',
        id: 'phone'
      }}
      onChange={(phone, country) => props.onChange(phone, country)}
    />
    {props.error && <div className='error_container'>{props.error.message}</div>}
  </label>
))

export default PhoneInputWrapper
